export * from './aI.service';
import { AIService } from './aI.service';
export * from './aI.serviceInterface';
export * from './address.service';
import { AddressService } from './address.service';
export * from './address.serviceInterface';
export * from './al.service';
import { AlService } from './al.service';
export * from './al.serviceInterface';
export * from './catastralUnit.service';
import { CatastralUnitService } from './catastralUnit.service';
export * from './catastralUnit.serviceInterface';
export * from './contact.service';
import { ContactService } from './contact.service';
export * from './contact.serviceInterface';
export * from './district.service';
import { DistrictService } from './district.service';
export * from './district.serviceInterface';
export * from './finMath.service';
import { FinMathService } from './finMath.service';
export * from './finMath.serviceInterface';
export * from './indexPublicProperty.service';
import { IndexPublicPropertyService } from './indexPublicProperty.service';
export * from './indexPublicProperty.serviceInterface';
export * from './indexPublicTour.service';
import { IndexPublicTourService } from './indexPublicTour.service';
export * from './indexPublicTour.serviceInterface';
export * from './inquiryContact.service';
import { InquiryContactService } from './inquiryContact.service';
export * from './inquiryContact.serviceInterface';
export * from './location.service';
import { LocationService } from './location.service';
export * from './location.serviceInterface';
export * from './math.service';
import { MathService } from './math.service';
export * from './math.serviceInterface';
export * from './municipality.service';
import { MunicipalityService } from './municipality.service';
export * from './municipality.serviceInterface';
export * from './offerContact.service';
import { OfferContactService } from './offerContact.service';
export * from './offerContact.serviceInterface';
export * from './order.service';
import { OrderService } from './order.service';
export * from './order.serviceInterface';
export * from './property.service';
import { PropertyService } from './property.service';
export * from './property.serviceInterface';
export * from './propertyStatus.service';
import { PropertyStatusService } from './propertyStatus.service';
export * from './propertyStatus.serviceInterface';
export * from './propertyUser.service';
import { PropertyUserService } from './propertyUser.service';
export * from './propertyUser.serviceInterface';
export * from './public.service';
import { PublicService } from './public.service';
export * from './public.serviceInterface';
export * from './showPropertyPdf.service';
import { ShowPropertyPdfService } from './showPropertyPdf.service';
export * from './showPropertyPdf.serviceInterface';
export * from './showPublicProperty.service';
import { ShowPublicPropertyService } from './showPublicProperty.service';
export * from './showPublicProperty.serviceInterface';
export * from './showPublicPropertyPdf.service';
import { ShowPublicPropertyPdfService } from './showPublicPropertyPdf.service';
export * from './showPublicPropertyPdf.serviceInterface';
export * from './showPublicTour.service';
import { ShowPublicTourService } from './showPublicTour.service';
export * from './showPublicTour.serviceInterface';
export * from './showPublicTourPdf.service';
import { ShowPublicTourPdfService } from './showPublicTourPdf.service';
export * from './showPublicTourPdf.serviceInterface';
export * from './showTourPdf.service';
import { ShowTourPdfService } from './showTourPdf.service';
export * from './showTourPdf.serviceInterface';
export * from './stats.service';
import { StatsService } from './stats.service';
export * from './tour.service';
import { TourService } from './tour.service';
export * from './tour.serviceInterface';
export * from './tourStatus.service';
import { TourStatusService } from './tourStatus.service';
export * from './tourStatus.serviceInterface';
export * from './tourUser.service';
import { TourUserService } from './tourUser.service';
export * from './tourUser.serviceInterface';
export * from './wage.service';
import { WageService } from './wage.service';
export * from './wage.serviceInterface';
export const APIS = [AIService, AddressService, AlService, CatastralUnitService, ContactService, DistrictService, FinMathService, IndexPublicPropertyService, IndexPublicTourService, InquiryContactService, LocationService, MathService, MunicipalityService, OfferContactService, OrderService, PropertyService, PropertyStatusService, PropertyUserService, PublicService, ShowPropertyPdfService, ShowPublicPropertyService, ShowPublicPropertyPdfService, ShowPublicTourService, ShowPublicTourPdfService, ShowTourPdfService, StatsService, TourService, TourStatusService, TourUserService, WageService];
